/* ==========================================================================
   CounterRxjs > Template
   ========================================================================== */

/* Import modules */
const { html } = require('common-tags');

const { prepareDataConfig, addData } = require('@bluekiri/alexandria/helpers/dataHelpers');

const ButtonTemplate = require('../button-rxjs/template');

const configuration = require('./client/js/config');

/* Increment */
const increment = (context = {}) =>
    ButtonTemplate(
        addData(
            {
                icon: 'plus'
            },
            {
                type: configuration().type.increment
            }
        ),
        context
    );

/* Decrement */
const decrement = (context = {}) =>
    ButtonTemplate(
        addData(
            {
                icon: 'minus'
            },
            {
                type: configuration().type.decrement
            }
        ),
        context
    );

/* Render description */
const renderDescription = description => {
    if (!description) {
        return html('');
    }

    return html(`<span class='counter-rxjs__description'>${description}</span>`);
};

/* Render label */
const renderLabel = data => {
    /* Data */
    const { label, description } = data;

    if (!label && !description) {
        return html('');
    }

    return html(`
        <p class='counter-rxjs__label'>
            <span>${label}</span>
            ${renderDescription(description)}
        </p>
    `);
};

/**
 * CounterRxjs template
 * @param {object} data Object containing the data model for this component.
 * @returns {string} Html
 */
module.exports = function Template(data = {}, context = {}) {
    /* Data */
    const { config = {}, label = false, description = false, min = 0, max = 9, value = 0 } = data;
    const { styles = [] } = config;
    const { dataType } = prepareDataConfig(config.data);

    /* Template */
    return html(`
        <div class='${['counter-rxjs', ...styles].join(' ').trim('')}'
            data-component='${configuration().component}'
            ${dataType ? `data-type='${dataType}'` : ''}
            data-config='${JSON.stringify({
                min,
                max,
                value
            })}'>

            ${renderLabel({ label, description })}

            <div class='counter-rxjs__wrapper'>
                ${decrement(context)}
                <span class='counter-rxjs__value' data-value=''>${value}</span>
                ${increment(context)}
            </div>
        </div>
    `);
};
